// T2-C (owner 2026-10-08): Press splits the pieces among the tailors. No
// imports, so Jest can test it; the server checks everything again.

// "bagi rata": everyone gets the base; each leftover piece goes to the tailor
// chosen for it (C1: several leftovers may go to the same tailor)
export function bagiRata(target, ids, penerimaSisa = []) {
  const k = ids.length;
  if (!k || !(target > 0)) return { dasar: 0, sisa: 0, alokasi: [] };
  const dasar = Math.floor(target / k);
  const sisa = target % k;
  const pcs = Object.fromEntries(ids.map((id) => [id, dasar]));
  for (let i = 0; i < sisa; i += 1) {
    const id = ids.includes(penerimaSisa[i]) ? penerimaSisa[i] : ids[i % k];
    pcs[id] += 1;
  }
  return { dasar, sisa, alokasi: ids.map((id) => ({ operator_id: id, pcs: pcs[id] })) };
}

// error text, or null when the split may be sent
export function cekPembagian(mode, target, alokasi, alasan) {
  const isi = alokasi.filter((a) => a.pcs > 0);
  if (!isi.length) return "Pilih minimal satu penjahit";
  if (alokasi.some((a) => !Number.isInteger(a.pcs) || a.pcs < 0)) return "Isi pcs dengan angka bulat";
  const total = alokasi.reduce((s, a) => s + a.pcs, 0);
  if (total !== target) return `Jumlah pembagian ${total} pcs, harus ${target} pcs`;
  if (mode === "ATUR" && (alasan || "").trim().length < 5) return "Atur sendiri: alasan wajib (minimal 5 huruf)";
  return null;
}

// TARIF-JAHIT (T-2): Press splits every variasi line. `baris` =
// [{variasi_no, nama, target, alokasi}] -> the first error (prefixed with the
// line when there are several) or null.
export function cekBanyak(mode, baris, alasan) {
  for (const b of baris) {
    const e = cekPembagian(mode, b.target, b.alokasi, alasan);
    if (e) return baris.length > 1 ? `Variasi ${b.variasi_no}${b.nama ? ` (${b.nama})` : ""}: ${e}` : e;
  }
  return null;
}

// the body sent to the server: every allocation carries its variasi line
export function gabungAlokasi(baris) {
  return baris.flatMap((b) => b.alokasi.map((a) => ({ ...a, variasi_no: b.variasi_no ?? null })));
}
